<template>
  <List>
    <template v-slot:list-header>
      <nav class="navbar navbar-light bg-light">
        <div class="container-fluid">
          <div class="navbar-brand">Documents</div>

          <div class="nav-item">
            <div v-b-modal="'add-document'" class="btn btn-outline-primary">
              <b-icon-plus></b-icon-plus>
            </div>
          </div>

          <Modal id="add-document">
            <template v-slot:header>
              Add new document
            </template>

            <template v-slot:content="{ changed, close }">
              <Editor v-on="{ changed, saved: created(close) }"></Editor>
            </template>
          </Modal>
        </div>
      </nav>
    </template>

    <template v-slot:list-content>
      <KeyNav :keyLevel="1" :size="documents ? documents.length : 0" @selected="selectAtIndex">
        <template v-slot:default="{ preselected }">
          <div class="list-group">
            <router-link v-for="(document, index) in documents" :key="document.id" class="list-group-item" :class="[{ 'list-group-item-dark': preselected === index }]" active-class="active" :to="{ name: 'document', params: { documentId: document.id }}" tag="div">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ document.title }}</h5>
                <small>{{ document.date }}</small>
              </div>

              <p class="mb-1">{{ document.author }}</p>
              <small>Updated <time-ago refresh :datetime="document.updated_at"></time-ago></small>
            </router-link>
          </div>
        </template>
      </KeyNav>
    </template>

    <template v-slot:detail>
      <router-view></router-view>
    </template>
  </List>
</template>

<script>
  import gql from 'graphql-tag'
  
  import Modal from '../components/Editor';
  import Editor from '../components/editors/Document';

  import List from '../components/List';
  import TimeAgo from 'vue2-timeago'

  import KeyNav from '../components/KeyNav'

  const GET_DOCUMENTS = gql`
    query GetDocuments {
      documents(order_by: { date: desc }, limit: 10) {
        id
        title
        date
        author
        created_at
        updated_at
      }
    }
  `

  export default {
    components: {
      List,
      TimeAgo,
      Modal,
      Editor,
      KeyNav
    },

    methods: {
      created(callback) {
        return function(document, { cache }) {
          const data = cache.readQuery({ query: GET_DOCUMENTS });
          data.documents.splice(0, 0, document);

          cache.writeQuery({
            query: GET_DOCUMENTS,
            data
          })

          callback();
          this.$router.push({ name: 'document', params: { documentId: document.id } })
        }.bind(this)
      },

      selectAtIndex(index) {
        const document = this.documents[index];
        this.$router.push({ name: 'document', params: { documentId: document.id } })
      }
    },
    
    apollo: {
      documents: GET_DOCUMENTS
    }
  }
</script>

<style scoped>
  .list-group .btn:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .list-group > div {
    cursor: pointer;
  }
</style>